import { Typography, Button, Box } from '@mui/material';
import SuccessVerification from "../../img/kyc/successVerification.png"
import InitialVerification from "../../img/kyc/initialVerification.png"
import { ReactComponent as KycTick } from '../../img/kyc/kycVerifiedTick.svg';
import { ReactComponent as AssesRiskTick } from '../../img/kyc/assesRiskTick.svg';
import { ReactComponent as Arrow } from '../../img/kyc/assesArrow.svg';
import { useNavigate } from 'react-router-dom';
import { colors } from '../../Theme/tokens';

export default function QuestionaireStatus({questionaireClicked, setQuestionaireClicked, status}) {
    const navigate = useNavigate(false)

    const handleClick = () => {
        setQuestionaireClicked(false)
    }

  return (
    <Box sx={{ backgroundColor: colors.background.default, width: '100%', alignSelf: questionaireClicked ? "center" : "flex-start", height: "100%"}}>
            {status == false ? (
                !questionaireClicked ? (
                    <Button onClick={() => setQuestionaireClicked(true)}  sx={{width:"100%",display:"flex", height:{xs:'auto', sm:"78px !important"}, p:'16px', backgroundColor: colors.primary.main, '&:hover':{
                        backgroundColor: colors.primary.main
                      }}}>
                        <Box sx={{ width:"100%", display:"flex", justifyContent:"space-between", alignItems:"center"}}>
                            <Box sx={{display:"flex", gap:"10px", width:"100%", alignItems:"center"}}>
                                <AssesRiskTick/>
                                <Box sx={{display:"flex", flexDirection:"column", gap:"5px"}}>
                                    <Typography  sx={{ textAlign:"left", fontWeight:"600", fontSize:"14px", color: colors.primary.contrastText, lineHeight:"22px"}}>Assess Your Risk</Typography>
                                    <Typography  sx={{ fontWeight:"400", fontSize:"13px", color: colors.primary.contrastText, lineHeight:"19px"}}>Deposit, withdraw and trade</Typography>
                                </Box>                    
                            </Box>
                            <Box>
                                <Arrow />
                            </Box>
                        </Box>
                      </Button>
                ) : (
                    <Box sx={{display:'flex', flexDirection:'column', gap:'20px', py:2, backgroundColor:'white'}}>
                            <Box sx={{display:'flex', flexDirection:'column', gap:'10px'}}>
                                <Box 
                                sx={{alignItems:'center', alignSelf:'center', backgroundColor:'white'}}
                                component={'img'}
                                src={InitialVerification}
                                height={'200px'}
                                width={'auto'}
                                />
                            
                            </Box>
                            <Box sx={{display:"flex", flexDirection:"column", gap:"10px"}}>
                                <Typography variant='h5_1' sx={{ color: colors.text.primary, alignItems:'center', alignSelf:'center', fontSize:'25px', fontWeight:'500' }} >Assess Your Risk</Typography>
                                <Typography variant='h5_1' sx={{ color: colors.text.secondary, alignItems:'center', alignSelf:'center', fontSize:'18px', fontWeight:'400' }} >Deposit, withdraw and trade</Typography>
                            </Box>
                            <Button  onClick={() => navigate('/Questionnaire')} sx={{fontWeight:"600", height: '42px', mt:4,width:'100%', fontSize: '15px', padding: '10px', borderRadius: '8px !important', letterSpacing: '.6px', p:"10px", color: "white", backgroundColor: colors.primary.main, '&:hover': {backgroundColor: colors.primary.main}, maxWidth:"394px", display:"flex", alignSelf:"center" }} >
                            Assess Now
                            </Button>
                            <Button  onClick={handleClick} sx={{fontWeight:"500", width:'100%', fontSize: '15px', height: '42px', padding: '10px', borderRadius: '8px !important', letterSpacing: '.6px', p:"10px", color: "white", backgroundColor: colors.primary.main, '&:hover': {backgroundColor: colors.primary.main}, maxWidth:"394px", display:"flex", alignSelf:"center" }} >
                            Back
                            </Button>
                        </Box>
                )
            ) : (status == true ? (
                !questionaireClicked ? (
                    <Button onClick={() => setQuestionaireClicked(true)} sx={{width:"100%", display:"flex", height:{xs:'auto', sm:"78px"}, p:'10px', backgroundColor: colors.secondary.main, '&:hover':{
                        backgroundColor: colors.secondary.main
                      }}}>
                        
                        <Box sx={{ width:"100%", display:"flex", justifyContent:"space-between", alignItems:"center"}}>
                            <Box sx={{display:"flex", gap:"10px", width:"100%", alignItems:"center"}}>
                                <KycTick/>
                                <Box sx={{display:"flex", flexDirection:"column", gap:"5px"}}>
                                    <Typography  sx={{ textAlign:"left", fontWeight:"600", fontSize:"14px", color: colors.primary.contrastText, lineHeight:"22px"}}>Assessed</Typography>
                                    <Typography  sx={{ fontWeight:"400", fontSize:"13px", color: colors.primary.contrastText, lineHeight:"19px"}}>You have assessed your risks.</Typography>
                                </Box>                    
                            </Box>
                            <Box sx={{}}>
                                    <Arrow />
                            </Box>
                        </Box>
                      </Button>
                ) : (
                    <Box sx={{display:'flex', flexDirection:'column', gap:'20px', py:2, backgroundColor:'white'}}>
                            <Box sx={{display:'flex', flexDirection:'column', gap:'10px'}}>
                                <Box 
                                sx={{alignItems:'center', alignSelf:'center', backgroundColor:'white'}}
                                component={'img'}
                                src={SuccessVerification}
                                height={'200px'}
                                width={'auto'}
                                />
                            
                            </Box>
                            <Box sx={{display:"flex", flexDirection:"column", gap:"10px"}}>
                                <Typography variant='h5_1' sx={{ color: colors.text.primary, alignItems:'center', alignSelf:'center', fontSize:'25px', fontWeight:'600', letterSpacing:"0.5%" }} >Assessed </Typography>
                                <Typography variant='h5_1' sx={{ color: colors.text.secondary, alignItems:'center', alignSelf:'center', fontSize:'18px', fontWeight:'400' }} >You have assessed your risks.</Typography>
                            </Box>
                            <Button  onClick={handleClick} sx={{fontWeight:"500", mt:4,width:'100%', fontSize: '15px', height: '42px', padding: '10px', borderRadius: '8px !important', letterSpacing: '.6px', p:"10px", color: "white", backgroundColor: colors.primary.main, '&:hover': {backgroundColor: colors.primary.main}, maxWidth:"394px", display:"flex", alignSelf:"center" }} >
                            Back
                            </Button>
                        </Box>
                )
            ) : ("")
               
            )}
    </Box>
    
  )
}